<!--其它出库  -->
<template>
	<div class="info-box">
		<el-dialog title="车辆里程信息" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="920px" :before-close="cancle"
			top="10vh">
			<div>
						<div class="info-title">基本信息:</div>
						<!--  -->
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 单据编号: </span>
									<span class="ml15"> {{rowData.docCode||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 日期: </span>
									<span class="ml15"> {{dateTimeFormat(rowData.createdTime)||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 出车(Y)/回车(N): </span>
									<span class="ml15"> {{rowData.checkOpport||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 巡回计划: </span>
									<span class="ml15"> {{rowData.planCode||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 车辆: </span>
									<span class="ml15"> {{rowData.licensePlate||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 里程数(km): </span>
									<span class="ml15"> {{rowData.kilometrage||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
						</div>

					</div>
				<!--  -->
					<!-- 配送客商情况 -->
			
				<div class="info-title mt20">车辆检查:</div>
				<el-table class="mt20" :data="tableData" v-if="tableData.length>0" ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					 border style="width: 100%">
					 <el-table-column prop="itemName" label="检查类型"></el-table-column>
					 <el-table-column prop="checkResult" label="是否正常"></el-table-column>
					 <el-table-column prop="remark" label="描述"></el-table-column>
				</el-table>
				<div v-else class="tc mt15">暂无数据</div>
			<div class="info-title mt20">合计:</div>
						<!--  -->
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> ETC编码: </span>
									<span class="ml15"> {{rowData.etcCode||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> ETC金额: </span>
									<span class="ml15"> {{rowData.etcMoney||0}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> ETC余额: </span>
									<span class="ml15"> {{rowData.etcBalance||0}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 路线: </span>
									<span class="ml15"> {{rowData.routeName||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 主线路员: </span>
									<span class="ml15"> {{rowData.mainUserName||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 副路线员: </span>
									<span class="ml15"> {{rowData.secUserName||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 巡回计划日期: </span>
									<span class="ml15"> {{rowData.planDate||'无'}}</span>
								</div>
								
							</div>
							<!--  -->
						
							<!--  -->
						</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
			</span>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
import {dateTimeFormat} from '@/utils/common'
	export default {
		components: {
			
		},
		data() {
			return {
				dialogVisible: false,
				dateTimeFormat:null,
				ruleForm:{
					recordId: "",
					groupId: "",
				},
				rowData: {},
				tableData: [],
			}
		},
		created() {
			this.dateTimeFormat = dateTimeFormat
		},
		methods: {
			init(data) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.rowData = {}
					this.pageNo = 1
					this.ruleForm = {
						recordId: "",
						groupId: "",
					}
					if (data) {
						this.ruleForm.recordId = data.recordId
						this.ruleForm.groupId = data.groupId
						this.getInfo()
					}

				})


			},
			// 查询
			getInfo() {
				let that = this;
				that.$request.post(
						"kilometrageInfo",
						true, {
							recordId: that.ruleForm.recordId,
							groupId: that.ruleForm.groupId,
						}
					)
					.then((res) => {
						if (res) {
							that.tableData = res.data.carChecks
							that.rowData = res.data
						}
					})
			},
			// 取消
			cancle() {
				this.dialogVisible = false
				this.$emit("getList")
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.w90 {
		width: 110px;
	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}

	.mb10 {
		margin-bottom: 10px !important;
	}

	.w190 {
		width: 280px !important;
	}

	.info-box {
		/deep/ .el-dialog__body {
			height: 330px;
			overflow-y: auto;
		}
	}

	.info-title {
		background: #E5E5E5;
		color: #333;
		padding: 10px;
		box-sizing: border-box;
		font-size: 16px;
		font-weight: bold;

		img {
			vertical-align: bottom;
			display: block;
		}
	}

	.el-form-item {
		width: 420px;
	}

	.w330 {
		width: 330px;
	}

	.w420 {
		width: 420px !important;
		margin-right: 10px;
	}

	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
	}

	.opeartion {
		font-size: 18px;
	}

	.lh30 {
		line-height: 30px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}
	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
		color: #999;
	}
</style>
